import { formatCurrency } from '@/pages/table/utils/utils';
import CurrencyIcon, { TetherIconColorOptions } from '@/components/CurrencySymbolMask/CurrencyIcon';

const PotAmount = ({
  amount,
  bigBlind,
  shouldDisplayInBB,
  fill,
}: {
  amount: number;
  bigBlind: number;
  shouldDisplayInBB?: boolean;
  fill: string;
}) => {
  if (shouldDisplayInBB && bigBlind) {
    return `${formatCurrency(amount / bigBlind)} BB`;
  }

  return (
    <div className="ml-1 flex flex-row items-center" style={{ direction: 'ltr' }}>
      <CurrencyIcon fill={TetherIconColorOptions.white} />
      {formatCurrency(amount)}
    </div>
  );
};

export default PotAmount;
